import { openDB } from "idb";
import { _log } from "./utils/logger";
export const APP_NAME = "image_editor_bulk";
const DB_NAME = APP_NAME + "store";
const DB_VERSION = 1;
const STORE_PATTERN = APP_NAME + "pattern";
const STORE_STYLES = APP_NAME + "styles";
const STORE_GRADIENT = APP_NAME + "gradient";
const STORE_ANIMATION = APP_NAME + "animation";
const STORE_PRESET = APP_NAME + "preset";
const STORE_PRESET_GLOBAL = APP_NAME + "global";
const STORE_APP = "app";

class IndexedDb {
  database;
  db;

  constructor(database) {
    this.database = database;
  }

  async createObjectStore() {
    try {
      this.db = await openDB(this.database, DB_VERSION, {
        upgrade(db) {
          const objectStoreStyles = db.createObjectStore(STORE_STYLES, {
            keyPath: "id",
          });
          objectStoreStyles.createIndex("id", "id", { unique: true });
          objectStoreStyles.createIndex("pattern", "pattern", {
            unique: false,
          });

          const objectStorePattern = db.createObjectStore(STORE_PATTERN, {
            keyPath: "id",
          });
          objectStorePattern.createIndex("id", "id", { unique: true });
          objectStorePattern.createIndex("pattern", "pattern", {
            unique: false,
          });

          const objectStoreGradient = db.createObjectStore(STORE_GRADIENT, {
            keyPath: "id",
          });
          objectStoreGradient.createIndex("id", "id", { unique: true });
          objectStoreGradient.createIndex("gradient", "gradient", {
            unique: false,
          });

          const objectStoreAnimation = db.createObjectStore(STORE_ANIMATION, {
            keyPath: "id",
          });
          objectStoreAnimation.createIndex("id", "id", { unique: true });
          objectStoreAnimation.createIndex("animation", "animation", {
            unique: false,
          });

          const objectStorePreset = db.createObjectStore(STORE_PRESET, {
            keyPath: "id",
          });
          objectStorePreset.createIndex("id", "id", { unique: true });
          objectStorePreset.createIndex("preset", "preset", { unique: false });

          const objectStorePresetGlobal = db.createObjectStore(
            STORE_PRESET_GLOBAL,
            {
              keyPath: "id",
            }
          );
          objectStorePresetGlobal.createIndex("id", "id", { unique: true });
          objectStorePresetGlobal.createIndex("preset", "preset", {
            unique: false,
          });

          const objectStoreApp = db.createObjectStore(STORE_APP, {
            keyPath: "id",
          });
          objectStoreApp.createIndex("id", "id", { unique: true });
          objectStoreApp.createIndex("data", "data", { unique: false });
        },
      });
    } catch (error) {
      return false;
    }
  }

  async getDB() {
    if (this.db) return this.db;
    this.db = await openDB(this.database, DB_VERSION);
    return this.db;
  }

  async getValue(tableName, id) {
    await this.getDB();
    const tx = this.db.transaction(tableName, "readonly");
    const store = tx.objectStore(tableName);
    const result = await store.get(id);
    //console.log('Get Data ', JSON.stringify(result));
    return result;
  }

  async getAllValue(tableName) {
    await this.getDB();
    const tx = this.db.transaction(tableName, "readonly");
    const store = tx.objectStore(tableName);
    const result = await store.getAll();
    //console.log('Get All Data', JSON.stringify(result));
    return result;
  }

  async getByValue(tableName, value) {
    await this.getDB();
    const tx = this.db.transaction(tableName, "readonly");
    const store = tx.objectStore(tableName);
    const result = await store.index("type").getAll(value);
    log(result);
    //console.log('Get All Data', JSON.stringify(result));
    return result;
  }

  async putValue(tableName, value) {
    await this.getDB();
    const tx = this.db.transaction(tableName, "readwrite");
    const store = tx.objectStore(tableName);
    const result = await store.put(value);
    //console.log('Put Data ', JSON.stringify(result));
    return result;
  }

  async putBulkValue(tableName, values) {
    await this.getDB();
    const tx = this.db.transaction(tableName, "readwrite");
    const store = tx.objectStore(tableName);
    for (const value of values) {
      const result = await store.put(value);
      log("Put Bulk Data ", JSON.stringify(result));
    }
    return this.getAllValue(tableName);
  }

  async deleteValue(tableName, id) {
    await this.getDB();
    const tx = this.db.transaction(tableName, "readwrite");
    const store = tx.objectStore(tableName);
    const result = await store.get(id);
    if (!result) {
      //console.log('Id not found', id);
      return result;
    }
    await store.delete(id);
    //console.log('Deleted Data', id);
    return id;
  }
}
const indexedDb = new IndexedDb(DB_NAME);
export default indexedDb;

export async function putPattern(val) {
  const result = await indexedDb.putValue(STORE_PATTERN, val);
  return result;
}

export async function deletePattern(id) {
  const result = await indexedDb.deleteValue(STORE_PATTERN, id);
  return result;
}

export async function getPattern(id) {
  const result = await indexedDb.getValue(STORE_PATTERN, id);
  return result;
}

export async function getAllPatterns() {
  const result = await indexedDb.getAllValue(STORE_PATTERN);
  return result;
}

export async function putStyle(val) {
  const result = await indexedDb.putValue(STORE_STYLES, val);
  return result;
}

export async function deleteStyle(id) {
  const result = await indexedDb.deleteValue(STORE_STYLES, id);
  return result;
}

export async function getStyle(id) {
  const result = await indexedDb.getValue(STORE_STYLES, id);
  return result;
}

export async function getAllStyles() {
  const result = await indexedDb.getAllValue(STORE_STYLES);
  return result;
}

export async function putGradients(value) {
  value.id = Date.now();
  const result = await indexedDb.putValue(STORE_GRADIENT, value);
  return result;
}

export async function deleteGradients(id) {
  const result = await indexedDb.deleteValue(STORE_GRADIENT, id);
  return result;
}

export async function getGradient(id) {
  const result = await indexedDb.getValue(STORE_GRADIENT, id);
  return result;
}

export async function getAllGradient() {
  const result = await indexedDb.getAllValue(STORE_GRADIENT);
  return result;
}

export async function putAnimation(value) {
  value.id = Date.now();
  const result = await indexedDb.putValue(STORE_ANIMATION, value);
  return result;
}

export async function deleteAnimation(id) {
  const result = await indexedDb.deleteValue(STORE_ANIMATION, id);
  return result;
}

export async function getAnimation(id) {
  const result = await indexedDb.getValue(STORE_ANIMATION, id);
  return result;
}

export async function getAllAnimation() {
  const result = await indexedDb.getAllValue(STORE_ANIMATION);
  return result;
}

export async function putPreset(value) {
  // value.id = Date.now()
  const result = await indexedDb.putValue(STORE_PRESET, value);
  return result;
}

export async function putPresetGlobal(value) {
  _log("putPresetGlobal", value);
  // value.id = Date.now()
  const result = await indexedDb.putValue(STORE_PRESET_GLOBAL, value);
  return result;
}

export async function deletePreset(id) {
  const result = await indexedDb.deleteValue(STORE_PRESET, id);
  return result;
}

export async function deletePresetGlobal(id) {
  const result = await indexedDb.deleteValue(STORE_PRESET_GLOBAL, id);
  return result;
}

export async function getPreset(id) {
  const result = await indexedDb.getValue(STORE_PRESET, id);
  return result;
}

export async function getPresetGlobal(id) {
  const result = await indexedDb.getValue(STORE_PRESET_GLOBAL, id);
  return result;
}

export async function getAllPreset() {
  const result = await indexedDb.getAllValue(STORE_PRESET);
  return result;
}

export async function getAllPresetGlobaql() {
  const result = await indexedDb.getAllValue(STORE_PRESET_GLOBAL);
  return result;
}

export async function initDB() {
  await indexedDb.createObjectStore();
  window["appIsDBREady"] = true;
}
